import { FormattedMessage, defineMessage } from 'react-intl';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { PropTypes as PropTypes$1 } from '@micromag/core';
import { ScreenElement } from '@micromag/core/components';
import { useScreenSize, useScreenRenderContext, useViewerContext, useViewerWebView, usePlaybackContext, usePlaybackMediaRef } from '@micromag/core/contexts';
import { isHeaderFilled, isFooterFilled, getFooterProps, isTextFilled } from '@micromag/core/utils';
import Background from '@micromag/element-background';
import Container from '@micromag/element-container';
import Footer from '@micromag/element-footer';
import Header from '@micromag/element-header';
import Layout, { Spacer } from '@micromag/element-layout';
import Quote from '@micromag/element-quote';
import Text from '@micromag/element-text';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { Quote as Quote$1, Author, Container as Container$1 } from '@micromag/transforms/apple-news';

var styles = {"container":"micromag-screen-quote-container","background":"micromag-screen-quote-background","disabled":"micromag-screen-quote-disabled","hidden":"micromag-screen-quote-hidden","placeholder":"micromag-screen-quote-placeholder","content":"micromag-screen-quote-content","emptyQuote":"micromag-screen-quote-emptyQuote","emptyAuthor":"micromag-screen-quote-emptyAuthor","quote":"micromag-screen-quote-quote","withMargin":"micromag-screen-quote-withMargin","isPlaceholder":"micromag-screen-quote-isPlaceholder","layout":"micromag-screen-quote-layout"};

// NOTE: this might be better with a scroll

var propTypes = {
  layout: PropTypes.oneOf(['top', 'middle', 'bottom', 'split']),
  quote: PropTypes$1.textElement,
  author: PropTypes$1.textElement,
  spacing: PropTypes.number,
  background: PropTypes$1.backgroundElement,
  header: PropTypes$1.header,
  footer: PropTypes$1.footer,
  current: PropTypes.bool,
  active: PropTypes.bool,
  className: PropTypes.string
};
var defaultProps = {
  layout: 'top',
  quote: null,
  author: null,
  spacing: 20,
  background: null,
  header: null,
  footer: null,
  current: true,
  active: true,
  className: null
};
var QuoteScreen = function QuoteScreen(_ref) {
  var layout = _ref.layout,
    quote = _ref.quote,
    author = _ref.author,
    spacing = _ref.spacing,
    background = _ref.background,
    header = _ref.header,
    footer = _ref.footer,
    current = _ref.current,
    active = _ref.active,
    className = _ref.className;
  var _useScreenSize = useScreenSize(),
    width = _useScreenSize.width,
    height = _useScreenSize.height,
    resolution = _useScreenSize.resolution;
  var _useScreenRenderConte = useScreenRenderContext(),
    isView = _useScreenRenderConte.isView,
    isPreview = _useScreenRenderConte.isPreview,
    isPlaceholder = _useScreenRenderConte.isPlaceholder,
    isEdit = _useScreenRenderConte.isEdit;
  var _useViewerContext = useViewerContext(),
    viewerTopHeight = _useViewerContext.topHeight,
    viewerBottomHeight = _useViewerContext.bottomHeight,
    viewerBottomSidesWidth = _useViewerContext.bottomSidesWidth;
  var _useViewerWebView = useViewerWebView(),
    openWebView = _useViewerWebView.open;
  var _usePlaybackContext = usePlaybackContext(),
    muted = _usePlaybackContext.muted;
  var mediaRef = usePlaybackMediaRef(current);
  var isSplitted = layout === 'split';
  var isTopLayout = layout === 'top';
  var isMiddleLayout = layout === 'middle';
  var isBottomLayout = layout === 'bottom';
  var verticalAlign = isSplitted ? null : layout;
  var hasHeader = isHeaderFilled(header);
  var hasFooter = isFooterFilled(footer);
  var footerProps = getFooterProps(footer, {
    isView: isView,
    current: current,
    openWebView: openWebView,
    isPreview: isPreview
  });
  var hasQuote = isTextFilled(quote);
  var hasAuthor = isTextFilled(author);
  var quoteWithMargin = hasQuote && hasAuthor && !isSplitted;
  var backgroundPlaying = current && (isView || isEdit);
  var mediaShouldLoad = current || active;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty(_defineProperty({}, className, className), styles.isPlaceholder, isPlaceholder)]),
    "data-screen-ready": true
  }, /*#__PURE__*/React.createElement(Container, {
    width: width,
    height: height,
    className: styles.content
  }, /*#__PURE__*/React.createElement(Layout, {
    className: styles.layout,
    fullscreen: true,
    verticalAlign: verticalAlign,
    style: !isPlaceholder ? {
      padding: spacing,
      paddingTop: (!isPreview ? viewerTopHeight : 0) + (hasHeader ? spacing / 2 : spacing),
      paddingBottom: (!isPreview ? viewerBottomHeight : 0) + (hasFooter ? spacing / 2 : spacing)
    } : null
  }, !isPlaceholder && hasHeader ? /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: spacing
    }
  }, /*#__PURE__*/React.createElement(Header, header)) : null, !isPlaceholder && hasFooter && isMiddleLayout ? /*#__PURE__*/React.createElement(Spacer, {
    key: "spacer-cta-top"
  }) : null, !isPlaceholder && hasHeader && isBottomLayout ? /*#__PURE__*/React.createElement(Spacer, {
    key: "spacer-cta-top"
  }) : null, !isPlaceholder && hasHeader && !hasFooter && isMiddleLayout ? /*#__PURE__*/React.createElement(Spacer, {
    key: "spacer-cta-top"
  }) : null, /*#__PURE__*/React.createElement(ScreenElement, {
    key: "quote",
    placeholder: "quote",
    emptyLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "CrzYgw",
      defaultMessage: [{
        "type": 0,
        "value": "Quote"
      }]
    }),
    emptyClassName: styles.emptyQuote,
    isEmpty: !hasQuote
  }, hasQuote ? /*#__PURE__*/React.createElement(Quote, Object.assign({
    className: classNames([styles.quote, _defineProperty({}, styles.withMargin, quoteWithMargin)])
  }, quote)) : null), isSplitted ? /*#__PURE__*/React.createElement(Spacer, {
    key: "spacer"
  }) : null, /*#__PURE__*/React.createElement(ScreenElement, {
    key: "author",
    placeholder: "subtitle",
    emptyLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "xYqGzM",
      defaultMessage: [{
        "type": 0,
        "value": "Author"
      }]
    }),
    emptyClassName: styles.emptyAuthor,
    isEmpty: !hasAuthor
  }, hasAuthor ? /*#__PURE__*/React.createElement(Text, Object.assign({
    className: styles.author
  }, author)) : null), !isPlaceholder && hasFooter && (isTopLayout || isMiddleLayout) ? /*#__PURE__*/React.createElement(Spacer, {
    key: "spacer-cta-bottom"
  }) : null, !isPlaceholder && hasHeader && !hasFooter && isMiddleLayout ? /*#__PURE__*/React.createElement(Spacer, {
    key: "spacer-cta-bottom"
  }) : null, !isPlaceholder && hasFooter ? /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: spacing,
      paddingLeft: Math.max(viewerBottomSidesWidth - spacing, 0),
      paddingRight: Math.max(viewerBottomSidesWidth - spacing, 0)
    }
  }, /*#__PURE__*/React.createElement(Footer, footerProps)) : null)), !isPlaceholder ? /*#__PURE__*/React.createElement(Background, {
    background: background,
    width: width,
    height: height,
    resolution: resolution,
    playing: backgroundPlaying,
    muted: muted,
    shouldLoad: mediaShouldLoad,
    mediaRef: mediaRef,
    withoutVideo: isPreview,
    className: styles.background
  }) : null);
};
QuoteScreen.propTypes = propTypes;
QuoteScreen.defaultProps = defaultProps;

var transform = function transform(newStory, _ref) {
  var quote = _ref.quote,
    author = _ref.author;
  var _Quote = Quote$1(newStory, quote),
    quoteStory = _Quote.story,
    quoteComponent = _Quote.component;
  var _Author = Author(quoteStory, author),
    authorStory = _Author.story,
    authorComponent = _Author.component;
  var _Container = Container$1(authorStory, [].concat(_toConsumableArray(quoteComponent ? [quoteComponent] : []), _toConsumableArray(authorComponent ? [authorComponent] : []))),
    containerStory = _Container.story,
    containerComponent = _Container.component;
  return _objectSpread(_objectSpread({}, containerStory), {}, {
    components: [].concat(_toConsumableArray(newStory.components || []), _toConsumableArray(containerComponent ? [containerComponent] : []))
  });
};

// eslint-disable-next-line

var transforms = /*#__PURE__*/Object.freeze({
    __proto__: null,
    appleNews: transform
});

var definition = {
  id: 'quote',
  type: 'screen',
  group: {
    label: defineMessage({
      id: "fIawTr",
      defaultMessage: [{
        "type": 0,
        "value": "Text"
      }]
    }),
    order: 2
  },
  title: defineMessage({
    id: "3q9GPv",
    defaultMessage: [{
      "type": 0,
      "value": "Quote"
    }]
  }),
  component: QuoteScreen,
  layouts: ['top', 'middle', 'bottom', 'split'],
  transforms: transforms,
  fields: [{
    name: 'layout',
    type: 'screen-layout',
    defaultValue: 'top',
    label: defineMessage({
      id: "4iBXj2",
      defaultMessage: [{
        "type": 0,
        "value": "Layout"
      }]
    })
  }, {
    name: 'quote',
    type: 'heading-element',
    fieldType: 'multi',
    theme: {
      textStyle: 'heading2'
    },
    label: defineMessage({
      id: "88/Ge8",
      defaultMessage: [{
        "type": 0,
        "value": "Quote"
      }]
    })
  }, {
    name: 'author',
    type: 'text-element',
    theme: {
      textStyle: 'text'
    },
    label: defineMessage({
      id: "73hxYw",
      defaultMessage: [{
        "type": 0,
        "value": "Author"
      }]
    })
  }, {
    name: 'background',
    type: 'background',
    label: defineMessage({
      id: "+MPZRu",
      defaultMessage: [{
        "type": 0,
        "value": "Background"
      }]
    })
  }, {
    name: 'header',
    type: 'header',
    label: defineMessage({
      id: "rhuDxI",
      defaultMessage: [{
        "type": 0,
        "value": "Header"
      }]
    }),
    theme: {
      badge: {
        label: {
          textStyle: 'badge'
        },
        boxStyle: 'badge'
      }
    }
  }, {
    name: 'footer',
    type: 'footer',
    label: defineMessage({
      id: "g4nybp",
      defaultMessage: [{
        "type": 0,
        "value": "Footer"
      }]
    }),
    theme: {
      callToAction: {
        label: {
          textStyle: 'cta'
        },
        boxStyle: 'cta'
      }
    }
  }]
};

export { QuoteScreen, definition as default };
